import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

export const getRouter = () => {
  const queryClient = new QueryClient({
    // Sem isso toda navegação refaz as mesmas requisições (catálogo,
    // configurações da loja). 60s é curto o bastante para o admin ver
    // alterações rápido e longo o bastante para navegar sem refetch.
    defaultOptions: { queries: { staleTime: 60_000, gcTime: 5 * 60_000 } },
  });

  const router = createRouter({
    routeTree,
    context: { queryClient },
    scrollRestoration: true,
    defaultPreloadStaleTime: 0,
  });

  return router;
};
